export default "__VITE_ASSET__BxWnbHOA__"